import CircleIcon from '@mui/icons-material/Circle';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import React from 'react';

export interface ExpandableListLinkItem {
  label: string;
  href: string | undefined;
  target?: '_blank' | '_self';
}

interface ExpandableListProps {
  title: string;
  items: (string | ExpandableListLinkItem)[];
  emptyText?: string;
  mode?: 'bullet' | 'numbered' | 'none';
}

export const ExpandableList = ({
  title,
  items,
  emptyText = 'No items available',
  mode = 'none',
}: ExpandableListProps) => {
  return (
    <Accordion sx={{ borderTop: 'none' }}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">{title}</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            {emptyText}
          </Typography>
        ) : (
          <List dense>
            {items.map((item, index) => {
              const isLink = typeof item !== 'string';

              return (
                <ListItem key={index}>
                  {mode !== 'none' && (
                    <ListItemIcon sx={{ minWidth: 24 }}>
                      {mode === 'bullet' && <CircleIcon sx={{ fontSize: 6 }} />}

                      {mode === 'numbered' && (
                        <Typography sx={{ width: 16, textAlign: 'right', pr: 1 }}>
                          {index + 1}.
                        </Typography>
                      )}
                    </ListItemIcon>
                  )}

                  <ListItemText
                    primary={
                      isLink ? (
                        <Link
                          href={item.href}
                          target={item.target ?? '_blank'}
                          rel="noopener noreferrer"
                          underline="hover"
                        >
                          <Typography>{item.label}</Typography>
                        </Link>
                      ) : (
                        <Typography>{item}</Typography>
                      )
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
